import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import * as actions from 'modules/orders';
import * as account from 'modules/account';
import * as billing from 'modules/billing';
import Datetime from 'react-datetime';
import OrderList from 'components/dashboard/OrderList';
import InvoiceSearchForm from 'components/dashboard/InvoiceSearchForm';
import DownloadInvoicesDialog from 'components/dashboard/DownloadInvoicesDialog';
import { browserHistory } from 'react-router';
import SelectDateDialog from 'components/SelectDateDialog';
import Cookies from 'universal-cookie';
import AlertDialog from 'components/AlertDialog';
import MarkOrdersAsPaid from 'components/dashboard/MarkOrdersAsPaid';
import ReviewPrompt from 'components/ReviewPrompt';
import { injectIntl } from 'react-intl';

const universalCookies = new Cookies();

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.searchOrders = this.searchOrders.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onChangeLimit = this.onChangeLimit.bind(this);
    this.onRowSelect = this.onRowSelect.bind(this);
    this.onSelectAll = this.onSelectAll.bind(this);
    this.showSelectDateDialog = this.showSelectDateDialog.bind(this);
    this.showStornoDateDialog = this.showStornoDateDialog.bind(this);
    this.exportOrders = this.exportOrders.bind(this);

    this.state = {
      page: 1,
      limit: 20,
      filter: {},
      collapsed: Boolean(universalCookies.get('invoicebrowse_filters_collapse')),
      selected: {}
    }
  }

  onRowSelect(row, isSelected, e) {

    let { user } = this.props;

    let selected = {
      ...this.state.selected,
    }

    if (user.hasMultipleLocations) {
      selected = {};
    }

    selected[row.id] = isSelected;
    if (!isSelected)
      delete selected[row.id];

    this.setState({ selected });

  }

  onSelectAll(isSelected, rows) {

    let selected = {}
    if (!isSelected)
      this.setState({ selected });
    else {
      for (let i = 0; i < rows.length; i++) {
        selected[rows[i].id] = isSelected;
      }

      this.setState({ selected });
    }
  }

  componentDidUpdate() {
    let { hasError } = this.props;
    if (hasError) {
      this.alertErrrorDialog.show();
    } else {
      this.alertErrrorDialog.hide();
    }
  }
  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(actions.fetchOrders({
      ...this.state.filter,
      limit: this.state.limit
    }));

    dispatch(account.fetchAccount());

    dispatch(actions.initSocket());
  }

  onPageChange(page) {
    let filter = { ...this.state.filter };

    if (page > this.state.page) {
      //next
      filter = { ...filter, next: this.props.next, previous: null };
    }

    if (page < this.state.page) {
      //previous
      filter = { ...filter, next: null, previous: this.props.previous };
    }

    let { dispatch } = this.props;
    this.setState({
      page: page,
      selected: {},
      filter: {
        ...filter
      }
    });
    dispatch(actions.fetchOrders(filter));
  }

  onChangeLimit(limit) {
    let { dispatch } = this.props;
    this.setState({
      limit: limit,
      selected: {}
    });
    dispatch(actions.fetchOrders({
      ...this.state.filter,
      limit: limit,
    }));
  }

  searchOrders(filter) {
    let { dispatch } = this.props;
    this.setState({
      filter: filter,
      selected: {},
      page: 1
    })

    dispatch(actions.fetchOrders({
      ...filter,
      limit: this.state.limit,
    }));
  }

  exportOrders(settings) {
    let { dispatch, needUpgrade, user } = this.props;

    if (needUpgrade) {
      browserHistory.push('/billing');
    }
    else {
      if (user.hasMultipleLocations) {

        if (this.state.selected.id) {
          let selected = {};

          selected[this.state.selected.id] = true;

          if (this.state.selected.location_id) {
            settings.locationId = this.state.selected.location_id;
          }

          dispatch(actions.exportOrders(selected, settings));
        } else {
          dispatch(actions.exportOrders({}, settings));
        }
      }
      else
        dispatch(actions.exportOrders({ ...this.state.selected }, settings));
    }
  }

  showSelectDateDialog() {
    this.selectDateDialog.wrappedInstance.show();
  }

  showStornoDateDialog() {
    this.selectStornoDateDialog.wrappedInstance.show();
  }

  createInvoices(form) {
    form = form || {};
    let date = form.date || null;
    let { dispatch, needUpgrade, user } = this.props;
    if (needUpgrade) {
      browserHistory.push('/billing');
    }
    else {
      if (user.hasMultipleLocations) {
        if (this.state.selected.id) {
          let selected = {};
          if (this.state.selected.id)
            selected[this.state.selected.id] = true;
          dispatch(actions.createInvoices(selected, this.state.filter, date));
        } else
          dispatch(actions.createInvoices({ ...this.state.selected }, this.state.filter, date));
      }
      else
        dispatch(actions.createInvoices({ ...this.state.selected }, this.state.filter, date));
    }
    this.selectDateDialog.wrappedInstance.hide();
    this.setState({});
  }

  newInvoices(user, promptDialog) {
    if (user.useOrderDate && !user.hasMultipleLocations && !promptDialog) {
      setTimeout(() => {
        this.createInvoices();
      }, 300);
    } else {
      this.showSelectDateDialog();
    }
  }

  createOneInvoice(order) {
    let selected = {};

    selected[order.id] = true;
    this.setState({
      selected
    });

    let { user, dispatch } = this.props;
    let currentInvoicingdate = this.getCurrentInvoiceDate();
    let promptDialog = new Date(currentInvoicingdate) > new Date(order.created_at);

    if (!promptDialog && user.useOrderDate)
      dispatch(actions.fetchOrdersBegin(this.state.filter));

    setTimeout(() => {
      this.newInvoices(user, promptDialog);
    }, 300);

  }

  stornoOneInvoice(order, isCreditNote) {
    let { dispatch } = this.props;
    let selected = {};
    selected[order.id] = true;
    this.setState({
      selected
    });

    order.has_credit_note = isCreditNote;
    dispatch(actions.stornoInvoices(selected, this.state.filter, order.date_storno, order));
  }

  markOrdersAsPaid(form) {

    let lines = form.ordersCSV.split('\n');
    let orders = [];
    for (let i = 0; i < lines.length; i++){
      let line = lines[i];
      let chunks = line.split(',');
      if (chunks.length === 2){
        orders.push({
          name: chunks[0].trim(),
          amount: chunks[1].trim()
        })
      }
    }

    let { dispatch } = this.props;
    dispatch(actions.markOrdersAsPaid(orders));
  }

  stornoInvoices(form) {
    let { dispatch, needUpgrade, user } = this.props;

    if (needUpgrade) {
      browserHistory.push('/billing');
    }
    else {
      if (user.hasMultipleLocations) {
        if (this.state.selected.id) {
          let selected = {};
          selected[this.state.selected.id] = true;
          dispatch(actions.stornoInvoices(selected, this.state.filter, form.date));
        } else
          dispatch(actions.stornoInvoices({ ...this.state.selected }, this.state.filter, form.date));
      }
      else
        dispatch(actions.stornoInvoices({ ...this.state.selected }, this.state.filter, form.date));
    }
    this.selectStornoDateDialog.wrappedInstance.hide();
    this.setState({});

  }

  showDownloadInvoicesDialog() {
    this.downloadInvoicesDialog.getWrappedInstance().wrappedInstance.show();
  }

  downloadInvoices(settings) {
    this.exportOrders(settings);

    this.downloadInvoicesDialog.getWrappedInstance().wrappedInstance.hide();
  }

  closeAlertErrorDialog() {
    let { dispatch } = this.props;
    this.alertErrrorDialog.hide();
    dispatch(actions.exportOrdersSuccess());
  }

  showMarkOrdersAsPaidDialog() {
    this.markOrdersAsPaidDialog.getWrappedInstance().wrappedInstance.show();
  }

  getPrimaryTheme() {
    let { user } = this.props;
    let { themes } = user;

    let theme;

    if (!themes)
      return theme;

    for (let i = 0; i < themes.length; i++) {
      if (themes[i].isPrimary)
        theme = themes[i].name;
    }

    if (!theme) {
      return 'Order';
    }

    return theme;
  }

  getCurrentInvoiceDate() {
    let { user } = this.props;
    let currentInvoiceDate = user.currentInvoiceDate;
    if (user.hasMultipleLocations) {
      let locationId = this.state.selected.location_id || -1;
      if (locationId === -1 || !user.locations || user.locations.length === 0) {
        return null;
      }

      for (var i = 0; i < user.locations.length; i++) {
        if (Number(user.locations[i].locationId) === locationId) {
          return user.locations[i].currentInvoiceDate;
        }
      }

      return null;
    }

    return currentInvoiceDate;
  }

  render() {
    let { u, orders, next, previous, totalCount, exporting, fetching, needUpgrade, invoicing, dispatch, status, user, updateOrder, error, intl } = this.props;
    const t = (id, values) => intl.formatMessage({ id }, values);

    if (user && user.profile && user.profile.subscription === "suspended") {
      return <Grid fluid>
        <h1>Your account has been suspended because the grace period has expired. <br /></h1>To activate it please send us an email to <a href="mailto:contact@growth-connections.com">contact@growth-connections.com</a>
      </Grid>
    }

    let isValidDate = function (current) {
      try {
        let currentInvoiceDate = this.getCurrentInvoiceDate();

        if (currentInvoiceDate === null)
          return true;


        var invoiceDate = Datetime.moment(currentInvoiceDate);
        invoiceDate.subtract(1, 'days');

        if (currentInvoiceDate === null)
          return true;

        return current.diff(invoiceDate) >= 0;
      } catch (e) {
        return false;
      }
    };

    let downloadStatus = exporting ? parseFloat(status).toFixed(2) + t('dashboard.completed') : (needUpgrade ? t('dashboard.upgradeBulkDownload') : <span>{t('dashboard.bulkDownload')}</span>);
    if (exporting && parseInt(status) === 0) {
      downloadStatus = t('dashboard.processing');
    }

    let theme = this.getPrimaryTheme();
    const showReviewPrompt = user && user.profile && user.profile.subscription === 'free'
        && (user.generated || 0) >= 10 && (user.monthlyGenerated || 0) >= 10
        && (user.reviewDismissCount || 0) < 5;

    // Check if user has email autopilot enabled but no SMTP configured
    const needsSmtpConfig = user && user.notifications && user.notifications.email &&
                           user.notifications.email.autopilot &&
                           (!user.notifications.smtp || !user.notifications.smtp.host);

    return (
      <div>
        {showReviewPrompt && <ReviewPrompt onDismiss={(resetCounter) => dispatch(billing.dismissReview(resetCounter))} />}

        {/* Warning banner for users with email autopilot but no SMTP */}
        {needsSmtpConfig && (
          <div style={{
            background: '#fef2f2',
            border: '1px solid #fca5a5',
            borderLeft: '4px solid #dc2626',
            borderRadius: '8px',
            padding: '12px 16px',
            margin: '16px 16px 0 16px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            <i className="fa fa-exclamation-triangle" style={{
              color: '#dc2626',
              fontSize: '18px'
            }}></i>
            <div style={{ flex: 1 }}>
              <strong style={{ color: '#991b1b', fontSize: '14px' }}>
                Email delivery is paused
              </strong>
              <span style={{ color: '#7f1d1d', fontSize: '13px', marginLeft: '8px' }}>
                Configure SMTP settings to resume sending invoices to customers.
              </span>
            </div>
            <button
              onClick={() => browserHistory.push(`/${intl.locale}/delivery`)}
              style={{
                background: '#dc2626',
                color: 'white',
                border: 'none',
                padding: '6px 16px',
                borderRadius: '6px',
                fontSize: '13px',
                fontWeight: 500,
                cursor: 'pointer',
                whiteSpace: 'nowrap'
              }}
            >
              Configure Now
            </button>
          </div>
        )}

        <Grid fluid>
          <div className="sidebar">

            <Col md={6}>
              <span>{!user.hasMultipleLocations && Object.keys(this.state.selected).length > 0 ? <span>{t('dashboard.selectedOrders', { count: Object.keys(this.state.selected).length })}</span> : <span>{t('dashboard.title')}&nbsp;</span>}
              </span>
            </Col>
            <Col md={6}>
              <div className="btn-group pull-right">
                <SelectDateDialog
                  initValues={{ date: new Date().toISOString() }}
                  ref={(r) => this.selectDateDialog = r}
                  dialogTitle={t('dashboard.chooseDate')}
                  message={t('dashboard.chooseIssueDate')}
                  closeButtonLabel={t('dashboard.cancel')}
                  submitButtonLabel={t('dashboard.createInvoices')}
                  isValidDate={isValidDate.bind(this)}
                  defaultValue={this.getCurrentInvoiceDate()}
                  onOk={this.createInvoices.bind(this)}
                />

                <SelectDateDialog
                  initValues={{ date: new Date().toISOString() }}
                  ref={(r) => this.selectStornoDateDialog = r}
                  dialogTitle={t('dashboard.chooseDate')}
                  message={t('dashboard.chooseIssueDate')}
                  closeButtonLabel={t('dashboard.cancel')}
                  submitButtonLabel={t('dashboard.storno')}
                  defaultValue={this.getCurrentInvoiceDate()}
                  isValidDate={isValidDate.bind(this)}
                  onOk={this.stornoInvoices.bind(this)}
                />

                <MarkOrdersAsPaid dialogTitle={t('dashboard.bulkOrderCapture')} closeButtonLabel={t('dashboard.close')} onOk={this.markOrdersAsPaid.bind(this)}
                  dispatch={dispatch} ref={(r) => this.markOrdersAsPaidDialog = r}
                />

                {theme && <DownloadInvoicesDialog initialValues={{
                  what: user.hasMultipleLocations ? 'all' : 'selected',
                  theme: theme,
                  format: 'pdf',
                  created_at_min: new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
                  created_at_max: new Date(new Date().setHours(23, 59, 0, 0)).toISOString()
                }}
                  ref={(r) => this.downloadInvoicesDialog = r}
                  dialogTitle={t('dashboard.bulkDownload')}
                  closeButtonLabel={t('dashboard.cancel')}
                  user={user}
                  intl={intl}
                  onOk={this.downloadInvoices.bind(this)}
                  dispatch={dispatch}
                />
                }
                <div className="btn-group">
                  {!needUpgrade && Object.keys(this.state.selected).length > 0 && <button disabled={invoicing || user.autoInvoicingMode !== "manual"} title={user.autoInvoicingMode !== "manual" ? t('dashboard.cannotCreateAutopilot') : t('dashboard.createInvoices')} className="btn btn-default btn-sm create-orders-button" onClick={this.newInvoices.bind(this, user)}><i className={invoicing ? "fa fa-spin fa-spinner" : "fa fa-plus"}></i>&nbsp;{invoicing ? t('dashboard.creatingInvoices') : t('dashboard.bulkCreateInvoices')}</button>}
                  <button disabled={exporting} title={t('dashboard.exportInvoices')} className={needUpgrade ? "btn btn-success btn-sm download-orders-button" : "btn btn-success btn-sm download-orders-button"} onClick={() => {
                    if (needUpgrade)
                      location.href = '/billing';
                    else
                      this.showDownloadInvoicesDialog.call(this)
                  }}>
                    <i className={exporting ? "fa fa-spin fa-spinner" : "fa fa-download"}></i>&nbsp;{downloadStatus}
                  </button>
                  <button onClick={this.showMarkOrdersAsPaidDialog.bind(this)} className="btn btn-sm btn-default">{t('dashboard.capturePayments')}</button>
                  <button id="filter-orders-btn" title={t('dashboard.filterOrders')} onClick={() => {
                    this.setState({
                      collapsed: !this.state.collapsed
                    });
                    universalCookies.set('invoicebrowse_filters_collapse', !this.state.collapsed);
                    window && window.scrollTo(0, 0);

                  }} className="btn btn-sm btn-default"><i className={this.state.collapsed ? "fa fa-filter" : "fa fa-times-circle"}>&nbsp;</i>{this.state.collapsed ? t('dashboard.showFilters') : t('dashboard.hideFilters')}</button>
                </div>

              </div>
            </Col>
          </div>

          <Row>
            <Col md={12} className={this.state.collapsed ? "collapsable" : "collapsable open"}>
              <InvoiceSearchForm fetching={fetching} onSearch={this.searchOrders} />
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <OrderList
                user={user}
                updateOrder={updateOrder}
                isValidDate={isValidDate}
                filter={this.state.filter}
                dispatch={dispatch}
                fetching={fetching}
                isValidDate={isValidDate.bind(this)}
                currentInvoiceDate={this.getCurrentInvoiceDate()}
                onRowSelect={this.onRowSelect}
                onSelectAll={this.onSelectAll}
                page={this.state.page}
                sizePerPage={this.state.limit}
                onPageChange={this.onPageChange}
                onSizePerPageList={this.onChangeLimit}
                totalCount={totalCount}
                onCreate={this.createOneInvoice.bind(this)}
                onStorno={this.stornoOneInvoice.bind(this)}
                list={orders}
                next={next}
                previous={previous}
              /><br /><br />

            </Col>
          </Row>
        </Grid>
        <AlertDialog
          ref={instance => {
            this.alertErrrorDialog = instance
          }}
          onOk={this.closeAlertErrorDialog.bind(this)}
          dialogTitle={t('dashboard.error')}
          message={error}
          submitButtonLabel={t('dashboard.close')} />
      </div>);
  }

}
function mapStateToProps(state) {
  return {
    user: state.account,
    u: state.user,
    orders: state.orders.list,
    next: state.orders.next,
    previous: state.orders.previous,
    fetching: state.orders.fetching,
    exporting: state.orders.exporting,
    invoicing: state.orders.invoicing,
    status: state.orders.status,
    sessionId: state.orders.sessionId,
    stornoing: state.orders.stornoing,
    needUpgrade: state.orders.needUpgrade,
    totalCount: state.orders.totalCount,
    updateOrder: state.orders.updateOrder,
    hasError: state.orders.hasError,
    error: state.orders.error
  };
}


export default injectIntl(connect(mapStateToProps)(Dashboard));



// WEBPACK FOOTER //
// app/containers/Dashboard.jsx